export class LimiteGeralModel{
	valorMaximoPorDia?: number;
	valorPorDia?: number;
	valorPorDiaSolicitado?: number;
	tempoEsgotado?: number;
	tipo?: LimiteTipoPeriodo;
	valor?: number;
	proximoDiaUtil: string;
	diaUtilHoje: boolean;
	faixaHorario?: LimitePixFaixaHorarioModel;
}

export class LimitePixFaixaHorarioModel{
	horarioInicial?: string;
	horarioFinal?: string;
	prazoCompensacao?: string;
	tipoTransacaoDisponivel: TipoTransacaoDisponivel;
}

export enum TipoTransacaoDisponivel {
	AGENDAR_TRANSACOES = 'AGENDAR_TRANSACOES',
	REALIZAR_AGENDAR_TRANSACOES = 'REALIZAR_AGENDAR_TRANSACOES',
}

export enum LimiteTipoPeriodo{
	TEF_DIURNO = 'TEF_DIURNO',
	TEF_NOTURNO = 'TEF_NOTURNO',
	DOC_DIURNO = 'DOC_DIURNO',
	DOC_NOTURNO = 'DOC_NOTURNO',
	TED_DIURNO = 'TED_DIURNO',
	TED_NOTURNO = 'TED_NOTURNO',
	PIX_DIURNO = 'PIX_DIURNO',
	PIX_NOTURNO = 'PIX_NOTURNO',
	PIX_TITULARIDADE_SEGURA_DIURNO = 'PIX_TITULARIDADE_SEGURA_DIURNO',
	CARTAO_DIURNO = 'CARTAO_DIURNO',
	CARTAO_NOTURNO = 'CARTAO_NOTURNO',
	BOLETO_DIURNO = 'BOLETO_DIURNO',
	BOLETO_NOTURNO = 'BOLETO_NOTURNO',
	CONVENIO_DIURNO = 'CONVENIO_DIURNO',
	CONVENIO_NOTURNO = 'CONVENIO_NOTURNO',
	TRIBUTO_FEDERAL_DIURNO = 'TRIBUTO_FEDERAL_DIURNO',
	TRIBUTO_FEDERAL_NOTURNO = 'TRIBUTO_FEDERAL_NOTURNO',
	INVESTIMENTO_DIURNO = 'INVESTIMENTO_DIURNO',
	INVESTIMENTO_NOTURNO = 'INVESTIMENTO_NOTURNO',
	QRCODE_PIX_SAQUE_TROCO_DIURNO = 'QRCODE_PIX_SAQUE_TROCO_DIURNO',
	QRCODE_PIX_SAQUE_TROCO_NOTURNO = 'QRCODE_PIX_SAQUE_TROCO_NOTURNO'
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/payment-securities/models/payment-limits-v2.ts